// extracted by mini-css-extract-plugin
export default {"addVacations":"Vacations_addVacations__lkm4m","customFileUpload":"Vacations_customFileUpload__YeL4Z"};